import { BreadcrumbPage } from '@/components/ui/breadcrumb';
import { Skeleton } from '@/components/ui/skeleton';
import useWebhooks from '@/hooks/useWebhooks';

import { WebhookTypeBadge } from './WebhookTypeBadge';

interface WebhookBreadcrumbNameProps {
  brainId: string;
  webhookId: string;
}

export const WebhookBreadcrumbName = ({ brainId, webhookId }: WebhookBreadcrumbNameProps) => {
  const { webhook } = useWebhooks(brainId, webhookId);

  if (!webhook) {
    return <Skeleton className="h-4 w-30" />;
  }

  return (
    <>
      <BreadcrumbPage className="truncate">{webhook.name}</BreadcrumbPage>
      <WebhookTypeBadge webhook={webhook} />
    </>
  );
};
